import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "toast-container position-fixed bottom-0 end-0 p-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Toast = _resolveComponent("Toast");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
            return (_openBlock(), _createBlock(_component_Toast, {
                key: toast.id,
                toast: toast
            }, null, 8, ["toast"]));
        }), 128))
    ]));
}
